import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['message'];

  connect() {
    // Auto-dismiss après 5 secondes
    this.messageTargets.forEach((message) => {
      setTimeout(() => {
        this.dismissMessage(message);
      }, 5000);
    });
  }

  // Handle dynamically added flash messages (e.g. from Turbo Stream responses)
  messageTargetConnected(message) {
    setTimeout(() => {
      this.dismissMessage(message);
    }, 5000);
  }

  dismiss(event) {
    this.dismissMessage(event.currentTarget.closest('[data-flash-target="message"]'));
  }

  dismissMessage(message) {
    message.classList.add('opacity-0', 'translate-x-full');
    setTimeout(() => {
      message.remove();
    }, 300);
  }
}
